<!-- User -->
<div class="app-navbar-item" [ngClass]="itemClass">
	@if (user) {
		<div
			class="cursor-pointer symbol symbol-circle d-flex justify-content-center align-items-center"
			[ngClass]="userAvatarClass"
			data-kt-menu-trigger="{default: 'click', lg: 'click'}"
			data-kt-menu-attach="parent"
			data-kt-menu-placement="bottom-end"
		>
			<span class="round symbol-label font-size-h5 fw-bold text-primary">
				{{ user?.name | initials }}
			</span>
			<span class="fw-bold text-primary font-size-base d-none d-md-inline ms-3">
				{{ user?.name }}
			</span>
			<div class="btn btn-icon-primary cursor-pointer p-0 ms-3 me-2">
				<span [inlineSVG]="'./assets/media/icons/duotune/arrows/arr072.svg'" class="svg-icon svg-icon-sm m-0"></span>
			</div>
			<app-user-inner data-kt-menu="true" [user]="user"></app-user-inner>
		</div>
	}
</div>

<!-- Active company -->
<div class="app-navbar-item" [ngClass]="itemClass">
	<div [ngClass]="btnClass" data-kt-menu-trigger="{default: 'click', lg: 'click'}" data-kt-menu-attach="parent" data-kt-menu-placement="bottom-end">
		<app-keenicon name="office-bag" class="fs-2"></app-keenicon>
	</div>
	<app-active-company [selectedCompany]="companiesService.company$ | async" />
</div>

<!-- Companies -->
<div class="app-navbar-item" [ngClass]="itemClass">
	<div [ngClass]="btnClass" data-kt-menu-trigger="{default: 'click', lg: 'click'}" data-kt-menu-attach="parent" data-kt-menu-placement="bottom-end">
		<app-keenicon name="element-11" class="fs-2"></app-keenicon>
	</div>
	<app-header-companies [selectedCompany]="company$ | async" />
</div>
